(() => {
  const addCalendarDays=(start,count)=>{
    const date=new Date(start);
    date.setUTCDate(date.getUTCDate()+count);
    return date;
  };
  const init = () => {
    const paris=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const part=name=>paris.find(p=>p.type===name).value;
    const today=new Date(`${part('year')}-${part('month')}-${part('day')}T12:00:00Z`);
    const format=new Intl.DateTimeFormat('fr-FR',{timeZone:'UTC',day:'numeric',month:'short'});
    document.querySelectorAll('[data-sn-delivery]').forEach(el=>{
      el.replaceChildren(document.createTextNode('Livraison estimée du '));const strong=document.createElement('strong');strong.textContent=`${format.format(addCalendarDays(today,7))} au ${format.format(addCalendarDays(today,15))}`;el.append(strong);
    });
    document.querySelectorAll('.sn-wa:not([data-ready])').forEach(root=>{
      root.dataset.ready='true';const toggle=root.querySelector('.sn-wa__toggle'),panel=root.querySelector('.sn-wa__panel'),close=root.querySelector('.sn-wa__close');
      const hide=()=>{panel.hidden=true;toggle.setAttribute('aria-expanded','false');toggle.focus();};
      toggle.addEventListener('click',()=>{panel.hidden=!panel.hidden;toggle.setAttribute('aria-expanded',String(!panel.hidden));if(!panel.hidden)close.focus();});close.addEventListener('click',hide);
      root.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden)hide();});
    });
    document.querySelectorAll('.sp-desc:not([data-segmented])').forEach(root=>{
      root.dataset.segmented='true';let content=null;
      Array.from(root.childNodes).forEach(node=>{
        if(node.nodeType===1 && node.tagName==='H2'){
          const detail=document.createElement('details');detail.className='sn-topic';const summary=document.createElement('summary');summary.textContent=node.textContent;detail.append(summary);content=document.createElement('div');detail.append(content);node.replaceWith(detail);
        }else if(content){content.append(node);}
      });
    });
    document.querySelectorAll('[data-sn-announcements]:not([data-ready])').forEach(root=>{
      root.dataset.ready='true';const slides=Array.from(root.querySelectorAll('[data-sn-slide]')),pause=root.querySelector('[data-sn-pause]');let index=0,paused=false;
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show=()=>slides.forEach((slide,i)=>{slide.hidden=i!==index;});
      show();if(reduced){root.classList.add('sn-announcements--static');slides.forEach(x=>x.hidden=false);pause.hidden=true;return;}
      pause.addEventListener('click',()=>{paused=!paused;pause.setAttribute('aria-pressed',String(paused));pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?'Reprendre le défilement':'Mettre le défilement en pause');});
      const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return;}if(paused||document.hidden||root.matches(':hover')||root.contains(document.activeElement))return;index=(index+1)%slides.length;show();},4500);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
